module.exports = __webpack_public_path__ + "static/img/main_logo.e25039b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/main_logo.png
// module id = B7M4
// module chunks = 44